<div class="row account-filter">
  <div class="col-md-12 col-lg-12 padding-l0 padding-r0 smallPadRgt0">
    <div class="row search-box-outer">
      <div class="col-md-3 col-lg-3 padding-r0 borderRight category-drop-outer">
        <div class="category-dropdown material-select">
          <!--<ng-select [items]="filterList"
                 name="ddlSeedReturnSearch"
                 [(ngModel)]="selectedFilter"
                 (ngModelChange)="enableDisableSearchButton()"
                 [virtualScroll]="true"
                 [closeOnSelect]="true"
                 [selectOnTab]="true"
                 [clearable]="false"
                 bindLabel="label"
                 bindValue="column"
                 labelForId="name"
                 [searchable]="false"
                 (change)="retainFilter(null, ' ')">
          </ng-select>-->
          <ng-select name="ddlOptions"
                     [(ngModel)]="selectedFilter"
                     (ngModelChange)="enableDisableSearchButton()"
                     [virtualScroll]="true"
                     [closeOnSelect]="true"
                     [selectOnTab]="true"
                     [clearable]="false"
                     labelForId="name"
                     [searchable]="false"
                     (change)="retainFilter(null, ' ')">
            <ng-option *ngFor="let option of filterList; let i = index;" [value]="option.column">
              <span [attr.data-testid]="'ddl-filter-opt_'+i">{{option.label}}</span>
            </ng-option>
          </ng-select>
        </div>
      </div>
      <div class="col-md-9 col-lg-9 padding-l4 padding-r0">
        <div class="material-select account-search">
          <div *ngIf="selectedFilter === 'productName'">
            <div class="search-box-outer">
              <div class="search-box wide100">
                <span class="search-icon">
                  <i class="fas fa-search"></i>
                </span>
                <div class="select-container">
                  <input (keyup.enter)="selectProductName($event)"
                         (ngModelChange)="validateProductSearch(productFilters.productName)"
                         (paste)="onPaste($event)"
                         [(ngModel)]="productFilters.productName" placeholder="Search..." type="text">
                </div>
              </div>
            </div>
          </div>

          <ng-select #marketingBrand name="ddlMarketingBrandSearch" *ngIf="selectedFilter === 'marketingBrand'"
                     [items]="marketingBrandMasterList"
                     placeholder="Search..."
                     class="custom-select-grower"
                     [multiple]="true"
                     [hideSelected]="true"
                     [(ngModel)]="productFilters.marketingBrand"
                     [virtualScroll]="true"
                     bindLabel="value"
                     bindValue="value"
                     [closeOnSelect]="true"
                     [searchFn]="filterSearchFn"
                     (change)="retainFilter(marketingBrand,'MarketingBrand')">
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="dropdown-template">
                <div class="row">
                  <div class="col-md-8">
                    <p class="name">
                      {{item.value}}
                    </p>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
              <div class="ng-option disabled">
                No data found for "{{searchTerm}}"
              </div>
            </ng-template>
          </ng-select>

          <ng-select #packageSize name="ddlpackageSizeSearch" *ngIf="selectedFilter === 'packageSize'"
                     [items]="packageSizeMasterList"
                     placeholder="Search..."
                     class="custom-select-grower"
                     [multiple]="true"
                     [hideSelected]="true"
                     [(ngModel)]="productFilters.packageSize"
                     [virtualScroll]="true"
                     bindLabel="value"
                     bindValue="value"
                     [closeOnSelect]="true"
                     [searchFn]="filterSearchFn"
                     (change)="retainFilter(packageSize,'PackageSize')">
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="dropdown-template">
                <div class="row">
                  <div class="col-md-8">
                    <p class="name">
                      {{item.value}}
                    </p>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
              <div class="ng-option disabled">
                No data found for "{{searchTerm}}"
              </div>
            </ng-template>
          </ng-select>

          <ng-select #packageSize name="ddlseedSizeSearch" *ngIf="selectedFilter === 'seedSize'"
                     [items]="seedSizeMasterList"
                     placeholder="Search"
                     class="custom-select-grower"
                     [multiple]="true"
                     [hideSelected]="true"
                     [(ngModel)]="productFilters.seedSize"
                     [virtualScroll]="true"
                     bindLabel="value"
                     bindValue="value"
                     [closeOnSelect]="true"
                     [searchFn]="filterSearchFn"
                     (change)="retainFilter(seedSize,'SeedSize')">
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="dropdown-template">
                <div class="row">
                  <div class="col-md-8">
                    <p class="name">
                      {{item.value}}
                    </p>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
              <div class="ng-option disabled">
                No data found for "{{searchTerm}}"
              </div>
            </ng-template>
          </ng-select>

          <div *ngIf="selectedFilter === 'technology'">
            <div class="search-box-outer">
              <div class="search-box wide100">
                <span class="search-icon">
                  <i class="fas fa-search"></i>
                </span>
                <div class="select-container">
                  <input (keyup.enter)="selectTechnology($event)"
                         (ngModelChange)="validateProductSearch(productFilters.technology)"
                         (paste)="onPaste($event)"
                         [(ngModel)]="productFilters.technology" placeholder="Search..." type="text">
                </div>
              </div>
            </div>
          </div>

          <ng-select #treatment name="ddlTreatmentSearch" *ngIf="selectedFilter === 'treatment'"
                     [items]="treatmentMasterList"
                     placeholder="Search..."
                     class="custom-select-grower"
                     [multiple]="true"
                     [hideSelected]="true"
                     [(ngModel)]="productFilters.treatment"
                     [virtualScroll]="true"
                     bindLabel="value"
                     bindValue="value"
                     [closeOnSelect]="true"
                     [searchFn]="filterSearchFn"
                     (change)="retainFilter(Treatment,'Treatment')">
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="dropdown-template">
                <div class="row">
                  <div class="col-md-8">
                    <p class="name">
                      {{item.value}}
                    </p>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
              <div class="ng-option disabled">
                No data found for "{{searchTerm}}"
              </div>
            </ng-template>
          </ng-select>
          <ng-select #itemNo name="ddlItemNoSearch" *ngIf="selectedFilter === 'itemNumber'"
                     [items]="invoicedProductList"
                     placeholder="Search..."
                     class="custom-select-grower"
                     [multiple]="true"
                     [hideSelected]="true"
                     [(ngModel)]="productFilters.itemNo"
                     [virtualScroll]="true"
                     bindLabel="value"
                     bindValue="value"
                     [closeOnSelect]="true"
                     [searchFn]="filterSearchFn"
                     (change)="retainFilter(itemNo,'ItemNo')">
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="dropdown-template">
                <div class="row">
                  <div class="col-md-8">
                    <p class="name">
                      {{item.value}}
                    </p>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
              <div class="ng-option disabled">
                No data found for "{{searchTerm}}"
              </div>
            </ng-template>
          </ng-select>

          <ng-select #itemNo name="ddlLotNoSearch" *ngIf="selectedFilter === 'lotNumber'"
                     [items]="lotNumberList"
                     placeholder="Search..."
                     class="custom-select-grower"
                     [multiple]="true"
                     [hideSelected]="true"
                     [(ngModel)]="productFilters.lotNumber"
                     [virtualScroll]="true"
                     bindLabel="value"
                     bindValue="value"
                     [closeOnSelect]="true"
                     [searchFn]="filterSearchFn"
                     (change)="retainFilter(lotNumber,'LotNo')">
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="dropdown-template">
                <div class="row">
                  <div class="col-md-8">
                    <p class="name">
                      {{item.value}}
                    </p>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
              <div class="ng-option disabled">
                No data found for "{{searchTerm}}"
              </div>
            </ng-template>
          </ng-select>

          <ng-select #itemNo name="ddlInvoiceNoSearch" *ngIf="selectedFilter === 'invoiceNumber'"
                     [items]="invoiceNumberList"
                     placeholder="Search..."
                     class="custom-select-grower"
                     [multiple]="true"
                     [hideSelected]="true"
                     [(ngModel)]="productFilters.invoiceNumber"
                     [virtualScroll]="true"
                     bindLabel="value"
                     bindValue="value"
                     [closeOnSelect]="true"
                     [searchFn]="filterSearchFn"
                     (change)="retainFilter(InvoiceNumber,'InvoiceNo')">
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="dropdown-template">
                <div class="row">
                  <div class="col-md-8">
                    <p class="name">
                      {{item.value}}
                    </p>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
              <div class="ng-option disabled">
                No data found for "{{searchTerm}}"
              </div>
            </ng-template>
          </ng-select>
        </div>
        <div class="search-btn">
          <button mat-raised-button class="btns" color="primary" [disabled]="disableFilterBtn" (click)="onFilter()" data-testid="btn-filter-search">Search</button>
        </div>
      </div>
    </div>
    <div class="row selected-chip">
      <div class="col-md-10 ">
        <div>
          <mat-chip-set>
            <mat-chip selected *ngFor="let filterValue of filterValueList">
              {{filterValue}}
              <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                <i class="fas fa-times text-right"></i>
              </a>
            </mat-chip>
          </mat-chip-set>
        </div>
      </div>
      <div class="col-md-2 text-right padding-r0" *ngIf="filterValueList.length > 0">
        <a href="Javascript:void(0);" class="clearAll" (click)="removeAllFilter()">Clear All</a>
      </div>
    </div>
  </div>
</div>
